import "react-quill/dist/quill.snow.css";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Form, message, Space, Spin } from "antd";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import styled from "styled-components";
import api from "../../../../api/api";
import { localStorage } from "@utils";
import { useTranslation } from "react-i18next";

const RootContainer = styled.div`
  position: relative;

  .ant-form {
    .buttons-wrapper {
      position: absolute;
      top: 0px;
      right: 12px;
    }

    .ant-btn {
      height: 48px;
      width: 172px;
    }

    .ant-btn-default {
      border: 1px solid ${(props) => props.theme.primaryColor} !important;
      background: ${(props) => props.theme.backgroundColor};

      :hover {
        background: ${(props) => props.theme.backgroundColor} !important;
      }

      .anticon {
        color: ${(props) => props.theme.primaryColor};
        font-weight: bold;
      }
    }

    .ant-btn-primary {
      :disabled {
        border: none !important;

        :hover {
          background: rgba(0, 0, 0, 0.04) !important;
          border: none !important;
        }
      }
    }
  }
`;

const Title = styled.div`
  padding-top: 16px;
  padding-bottom: 24px;
  font-size: 24px;
  font-weight: 700;
  color: #1e1e1e;
`;

const SpinWrapper = styled.div`
  padding-top: 35vh;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  width: 100%;
  text-align: right;
`;

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  // "strike",
  // "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
];

const TermsConditions = () => {
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [disabledSave, setDisabledSave] = useState(true);
  const [form] = Form.useForm();

  const {t} = useTranslation();

    const storeLang = localStorage.getStoreLang() || [];
    const langCount = storeLang?.length;

  useEffect(() => {
    getTerms();

    // eslint-disable-next-line
  }, []);

  const getTerms = () => {
    api
      .getTerms()
      .then(({ data }) => {
        setLoading(false);
        setData(data);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const onCancel = () => {
    if (!confirmLoading) {
      setIsEdit(false);
      form.resetFields();
    }
  };

  const onFieldsChange = (changedFields, allFields) => {
    setIsEdit(true);
    setDisabledSave(
      allFields.find(
        (field) =>
          field.value === undefined ||
          field.value === "" ||
          field.value === "<p><br></p>"
      )
    );
  };

  const successCallback = (payload) => {
    setData(payload);
    setIsEdit(false);
  };

  const onFinish = ({ primary, secondary }) => {
    if (!confirmLoading) {
      setConfirmLoading(true);
      let payload = {
        terms: {
          primary:primary,
          secondary:langCount === 2 ? secondary : null,
        },
      };
      api
        .updateTerms(payload)
        .then(() => {
          setConfirmLoading(false);
          message.success(t('success'));
          successCallback(payload);
        })
        .catch((error) => {
          setConfirmLoading(false);
          message.error(error);
        });
    }
  };

  const Loader = () => (
    <SpinWrapper>
      <Spin />
    </SpinWrapper>
  );

  return (
    <RootContainer>
      <Title>{t('terms_condition_title')}</Title>
      {loading ? (
        <Loader />
      ) : (
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            primary: data.terms?.primary,
            secondary: data.terms?.secondary,
          }}
          onFieldsChange={onFieldsChange}
          onFinish={onFinish}
        >
          {isEdit && (
            <Form.Item className="buttons-wrapper">
              <ButtonWrapper>
                <Space size={"large"}>
                  <Button
                    type="default"
                    icon={<CloseOutlined />}
                    onClick={onCancel}
                  >
                    {t('cancel')}
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={disabledSave}
                    loading={confirmLoading}
                    icon={<CheckOutlined />}
                  >
                    {t('save')}
                  </Button>
                </Space>
              </ButtonWrapper>
            </Form.Item>
          )}
          <Form.Item name={"primary"} label={`${storeLang[0]?.language}`}>
            <ReactQuill
              theme="snow"
              modules={modules}
              formats={formats}
              placeholder={t('write_terms_condition')}
            />
          </Form.Item>
          {langCount === 2 &&
          <Form.Item name={"secondary"} label={`${storeLang[1]?.language}`}>
            <ReactQuill
              theme="snow"
              modules={modules}
              formats={formats}
              placeholder={t('write_terms_condition')}
            />
          </Form.Item>
          }
        </Form>
      )}
    </RootContainer>
  );
};

export default TermsConditions;
